import React, { useState } from 'react';
import axios from 'axios';
import '../SignUp/Auth.css';
// import sankalvaxLogo from '../../assets/sankalvax-logo.png'; 
// ← Adjust if your logo is in a different folder

const Signup = ({ onToggleToLogin }) => {
  // ————————— SIGNUP STATE —————————
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const res = await axios.post('/api/signup', {
        name,
        email,
        password
      });
      setSuccess(res.data.message);
      setTimeout(() => {
        onToggleToLogin();
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Signup failed');
    }
  };

  // —————— ANIMATED “WELCOME…” TEXT ——————
  const welcomeText = "Welcome to Sankalvax Nexus";

  return (
    <div className="auth-box">
      {/*
        1) Exactly the same banner we used in Login.jsx.
           Logo + letter‐by‐letter “Welcome to Sankalvax Nexus”.
      */}
      <div className="welcome-banner">
        <img src="images/skx_logo.png" alt="Sankalvax Logo" className="welcome-logo" />
        <h1 className="welcome-text">
          {welcomeText.split("").map((char, idx) => {
            const isSpace = char === " ";
            return (
              <span
                key={idx}
                className={isSpace ? "char char-space" : "char"}
                style={{ animationDelay: `${idx * 0.12}s` }}
              >
                {char}
              </span>
            );
          })}
        </h1>
      </div>

      {/*
        2) The rest of your signup form — unchanged, except class names match Auth.css
      */}
      <h2>Create Your Account</h2>

      <form onSubmit={handleSignup} className="auth-form">
        {error && <p className="error-text">{error}</p>}
        {success && <p className="success-text">{success}</p>}

        <input
          className="input"
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          className="input"
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          className="input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit" className="submitbutton">
          Sign Up
        </button>
      </form>

      <div className="bottom-text">
        Already registered?{' '}
        <span className="signup-link" onClick={onToggleToLogin}>
          Log In
        </span>
      </div>
    </div>
  );
};

export default Signup;
